import { ClientBuildRegion } from '@lemon8/web-app-shared/i18n';
import { FC, useMemo } from 'react';

// preload > prefetch > preconnect > dns-prefetch
export const Preconnect: FC = () => {
  const preConnectHosts: string[] = useMemo(() => {
    switch (__BUILD_REGION__) {
      case ClientBuildRegion.VA:
        return ['p16-va.lemon8cdn.com', 'p16-sign-va.lemon8cdn.com', 'p16-lemon8-sign-va.ibyteimg.com'];
      case ClientBuildRegion.SG:
        return ['p16-sg.lemon8cdn.com', 'p16-sign-sg.lemon8cdn.com', 'p16-lemon8-sign-sg.ibyteimg.com'];
      case ClientBuildRegion.OCI:
      default:
        return [];
    }
  }, []);

  const preConnectAssetsHost: false | string = useMemo(() => {
    try {
      const { host } = new URL(__BUILD_PUBLIC_PATH);
      return host;
    } catch (e) {
      return false;
    }
  }, []);

  return (
    <>
      {preConnectHosts.map((host) => (
        <link key={host} rel="preconnect" href={`https://${host}`} />
      ))}
      {Boolean(preConnectAssetsHost) && <link rel="preconnect" href={`https://${preConnectAssetsHost}`} />}
    </>
  );
};
